import React from 'react';
import {Flex, Title, Text} from '@priority-software/priority-style-react';
import styles from './styles.module.scss';
import texts from '../../texts';
import moreInfoNoAccess from '../../../../images/moreInfo_noAccess.png';

export const MoreInfoNoAccess = () => {
    return (
        <Flex
            direction="column"
            justifyContent="center"
            componentClasses={styles.noAccessContainer}
        >
            <img src={moreInfoNoAccess} className={styles.image} alt="" />
            <Title skin="h5" textColor="primary-500" componentClasses={styles.title}>
                {texts.no_access_title}
            </Title>
            <Text
                tag="p"
                skin="paragraph-2"
                textColor="secondary-400"
                componentClasses={styles.message}
            >
                {texts.no_access_msg}
            </Text>
        </Flex>
    );
};
